"use client";

import { useState, useEffect } from "react";
import Link from "next/link";
import Image from "next/image";
import { Menu, X } from "lucide-react";

const NAV_LINKS = [
  { href: "#what-we-do", label: "What We Do" },
  { href: "#brands", label: "Our Brands" },
  { href: "#about", label: "About" },
  { href: "#contact", label: "Contact" },
] as const;

const PARTNER_URL = "https://bryanrivera.ai";

export default function SiteHeader() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  return (
    <header
      style={{
        position: "sticky",
        top: 0,
        zIndex: 50,
        height: "var(--header-height)",
        display: "flex",
        alignItems: "center",
        background: "var(--header-bg)",
        backdropFilter: "blur(14px)",
        WebkitBackdropFilter: "blur(14px)",
        borderBottom: "1px solid var(--border-dark)",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 1280,
          margin: "0 auto",
          padding: "0 var(--container-pad, 48px)",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 32,
        }}
        className="header-inner"
      >
        <Link href="#top" aria-label="AliraLink home" style={{ display: "flex", alignItems: "center" }}>
          <Image
            src="/brand/aliralink-horizontal-white.png"
            alt="AliraLink"
            width={180}
            height={30}
            priority
            style={{ height: 30, width: "auto", display: "block" }}
          />
        </Link>

        <nav
          className="header-nav-desktop"
          style={{ display: "flex", alignItems: "center", gap: 32 }}
        >
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              style={{
                font: "500 15px/1 var(--font-body)",
                color: "var(--text-secondary-large-dark)",
              }}
            >
              {l.label}
            </a>
          ))}
          <a
            href={PARTNER_URL}
            target="_blank"
            rel="noopener"
            className="hover-lift-btn cta-primary-inline"
            style={{
              font: "600 15px/1 var(--font-body)",
              color: "var(--bg-dark)",
              background: "var(--color-purple-light)",
              padding: "12px 22px",
              borderRadius: "var(--radius-btn)",
              transition: "all var(--transition-base)",
              display: "inline-block",
            }}
          >
            Get Started
          </a>
        </nav>

        <button
          type="button"
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
          className="header-nav-toggle"
          style={{
            display: "none",
            background: "transparent",
            border: "1px solid var(--border-dark)",
            borderRadius: 8,
            color: "var(--text-dark)",
            width: 44,
            height: 44,
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
          }}
        >
          {open ? <X size={22} strokeWidth={2} /> : <Menu size={22} strokeWidth={2} />}
        </button>
      </div>

      {open && (
        <div
          className="header-nav-drawer"
          role="dialog"
          aria-modal="true"
          style={{
            position: "fixed",
            top: "var(--header-height)",
            left: 0,
            right: 0,
            bottom: 0,
            background: "var(--bg-dark)",
            padding: "32px 24px",
            display: "flex",
            flexDirection: "column",
            gap: 24,
            zIndex: 49,
          }}
        >
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              style={{
                font: "500 20px/1.3 var(--font-body)",
                color: "var(--text-dark)",
                padding: "12px 0",
                borderBottom: "1px solid var(--border-dark)",
              }}
            >
              {l.label}
            </a>
          ))}
          <a
            href={PARTNER_URL}
            target="_blank"
            rel="noopener"
            onClick={() => setOpen(false)}
            style={{
              font: "600 16px/1 var(--font-body)",
              color: "var(--bg-dark)",
              background: "var(--color-purple-light)",
              padding: "16px 24px",
              borderRadius: "var(--radius-btn)",
              textAlign: "center",
              marginTop: 16,
            }}
          >
            Get Started
          </a>
        </div>
      )}
    </header>
  );
}
